export default __webpack_public_path__ + "static/media/s10.48038a60.png";